import axios from 'axios';
import { socketHandler } from '@fiverr-private/futile';
import pathfinder from '@fiverr-private/pathfinder';
import store from '../../store';
import { addItem } from '../../store/itemReducer/actions';
import * as apps from '../../enums/apps';
import { setUnreadCount } from '../../store/countReducer/actions';

const CONFIG = {
    [apps.APP_NAME_INBOX]: {
        fetchCounterRoute: pathfinder('inbox_counter_filter', { filter: 'unread' }),
        realtimeEvent: 'inbox_message_realtime_notification',
    },
    [apps.APP_NAME_NOTIFICATIONS]: {
        fetchCounterRoute: pathfinder('pinned_flashes_unread_count'),
        realtimeEvent: 'pinned_flash_realtime_notification',
    },
};

const initInbox = async () => initApp(apps.APP_NAME_INBOX);
const initNotifications = async () => initApp(apps.APP_NAME_NOTIFICATIONS);

const initApp = async (appName) => {
    const config = CONFIG[appName];
    const { fetchCounterRoute, realtimeEvent } = config;

    updateCounter(appName, fetchCounterRoute);
    registerRealtime(appName, realtimeEvent);
};

const updateCounter = async (appName, fetchCounterRoute) => {
    const counter = await fetchCounter(fetchCounterRoute);

    triggerCount(appName, counter);
};
const fetchCounter = async (route) => {
    const result = await axios(route);

    return result.data.count;
};
const triggerCount = (source, item) => store.dispatch(setUnreadCount(source, item));

const registerRealtime = (appName, realtimeEvent) =>
    socketHandler.on(realtimeEvent, (item) => triggerItem(appName, item));
const triggerItem = (source, item) => store.dispatch(addItem(source, item));

export { initInbox, initNotifications };
